<template>
  <b-col lg="12" class="color-bg-1">
    <b-container class="bv-example-row">
      <b-row>
        <b-col class="order-lg-2 text-center" lg="4" md="12" sm="12">
          <img :src="image" :alt="alt" class="w-100 my-5" />
        </b-col>

        <b-col class="order-lg-1 my-5" lg="8" md="12" sm="12">
          <slot name="p-1"></slot>
        </b-col>
      </b-row>
    </b-container>
  </b-col>
</template>

<script>
export default {
  name: "S503",
  props: ["image", "alt"],
};
</script>

<style scoped>
.color-bg-1 {
  background-color: var(--light-pink);
}
.text-11-style {
  font-weight: bold;
  color: var(--light-red);
}
.text-12-style {
  font-size: 25px;
  font-weight: bold;
}
.text-13-style {
  font-size: 25px;
  font-weight: bold;
  color: var(--light-red);
}

.button-klid-1 {
  background-color: var(--light-red);
  color: var(--light);
  margin-top: 40px;
  width: 120px;
  padding: 10px;
  font-weight: bold;
  border: 2px solid rgb(173, 72, 80);
}
.button-klid-1:hover {
  background-color: var(--light-pink);
  color: var(--light-red);
  border: 2px solid rgb(173, 72, 80);
  font-weight: bold;
}
.button-klid-2 {
  margin-top: 40px;
  width: 190px;
  padding: 10px;
  background-color: var(--light-pink);
  color: var(--light-red);
  border: 2px solid rgb(173, 72, 80);
  font-weight: bold;
}
.button-klid-2:hover {
  background-color: var(--light-red);
  color: var(--light);
  font-weight: bold;
}
</style>
